import { combineReducers } from 'redux';
import { activeRevisions } from './reducers/active-revisions.reducer';
// import { applicationGroups } from './reducers/application-groups';
import { permissionsList } from './reducers/permissions-list.reducer';
import { revisions } from './reducers/revisions.reducer';

export const permissions = combineReducers({
  permissionsList,
  activeRevisions,
  revisions,
  // applicationGroups,
});
